import { useCallback } from "react";
import { executeAction } from "../store/actions";
import { useChatServerDispatch } from "../utils/useChatServerDispatch";

export type ExecuteActionCallback = (text: string, token?: string) => void;

export function useExecuteActionCallback(): ExecuteActionCallback {
    const dispatch = useChatServerDispatch();

    return useCallback<ExecuteActionCallback>((text, token) => {
        dispatch(executeAction(text, token));
    }, [dispatch])
}
